import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { colors } from "style";
import Card from "components/Card";
import { PrimaryButton } from "components/Buttons";
import { InterviewTitle, InterviewSubtitle } from "components/VideoPresentation";

/**
 * ResumeInterviewStep
 *
 * @prop {number}   answeredCount
 * @prop {number}   totalCount
 * @prop {function} onResume
 */
const ResumeInterviewStep = ({ answeredCount, totalCount, onResume }) => (
  <div css={styles.container}>
    <InterviewTitle titleId="VideoPresentation.ResumeInterviewStep.Title" />
    <InterviewSubtitle subtitleId="VideoPresentation.ResumeInterviewStep.Subtitle" />

    <Card css={styles.card}>
      <div css={styles.badge}>
        <FormattedMessage id="VideoPresentation.ResumeInterviewStep.Badge" />
      </div>

      <p css={styles.progress_text}>
        <FormattedMessage
          id="VideoPresentation.ResumeInterviewStep.ProgressText"
          values={{
            total: <strong>{totalCount}</strong>,
            completed: <strong>{answeredCount}</strong>,
          }}
        />
      </p>
      <div css={styles.button_wrapper}>
        <PrimaryButton onClick={onResume}>
          <FormattedMessage id="VideoPresentation.ResumeInterviewStep.Button" />
        </PrimaryButton>
      </div>
    </Card>
  </div>
);

const styles = {
  container: css`
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,
  card: css`
    padding: 24px;
    border-radius: 20px;
    box-shadow: 0 8px 20px rgba(17, 24, 39, 0.06);
    display: flex;
    flex-direction: column;
    gap: 20px;
  `,
  badge: css`
    padding: 4px 12px;
    align-self: flex-start;
    border-radius: 999px;
    background: ${colors.purpleRainLight3};
    border: 1px solid ${colors.purpleRainDark2};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: ${colors.purpleRainBase};
    text-transform: uppercase;
  `,
  progress_text: css`
    font-size: 16px;
    color: ${colors.grayAnatomyBase};
    margin: 0;
  `,
  info_text: css`
    font-size: 15px;
    color: ${colors.purpleRainLight4};
    margin: 0;
  `,
  button_wrapper: css`
    display: flex;
    justify-content: center;
    padding-top: 8px;
  `,
};

ResumeInterviewStep.propTypes = {
  answeredCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  onResume: PropTypes.func.isRequired,
};

export default ResumeInterviewStep;
